import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap';
import { List } from 'rsuite';
import { Link, useNavigate } from 'react-router-dom';
import Information from '../../../../../Shared/Card/Information';
import { GetReinstatementInformationContent } from '../../../../../Shared/InformationContent/EiInformation';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner';
import ReviewPdf from '../../../../../Shared/Card/ReviewPdf';
import reinstatementService from '../../../../../../services/Public/Reinstatement/reinstatement.service';
import eiReinstatementService, { getSections } from '../../../../../../services/Public/Reinstatement/EI/eiReinstatement.service';
import shoppingCartService from '../../../../../../services/Public/shoppingCart.service';
import Swal from 'sweetalert2';

function ReviewPage() {
    const [hasIssues, setHasIssues] = useState(true)
    const [hasLoaded, setHasLoaded] = useState(true)
    const push = useNavigate();
    const reinstatementId = useSelector(x => x.currentApplicationId);
    const routes = useSelector(x => x.currentRoutes);
    const [allSections, setAllSections] = useState([]);
    const [sectionData, setSectionData] = useState({});
    const [violationIssuesHtml, setViolationIssuesHtml] = useState();
    const sectionId = 10;

    useEffect(() => {
        getSections().then(setAllSections);
        eiReinstatementService.eiGetSection(reinstatementId, sectionId).then((response) => {
            setSectionData(response.data);
        })
    }, [])
    const navigateToPage = (sectionId) => {
        push(routes.filter(x => x.sectionId == (sectionId))[0].route)
    }
    const validateReinstatement = () => {
        setHasLoaded(false);
        reinstatementService.validateReinstatement(reinstatementId).then((response) => {
            let errors = response.data.map((error, i) => {
                return <List.Item key={i} index={i} onClick={() => { navigateToPage(error.sectionId) }}>
                    Error{error.errors.length > 1 ? 's' : ''} in <b>{allSections.filter(x => x.id == error.sectionId)[0].sectionTitle}</b>: {error.errors.join(', ')}
                </List.Item>
            })
            if (response.data?.length)
                setViolationIssuesHtml(
                    <List hover bordered>
                        {errors}
                    </List>
                )
            else {
                setViolationIssuesHtml('')
                setHasIssues(false);
                Swal.fire("Validation Successful", `Your reinstatement passed all validation checks.  Click "OK", then click "Submit Reinstatement".`, 'success')
            }
            setHasLoaded(true);
        })
    }
    const submitReinstatement = () => {
        setHasLoaded(false);
        shoppingCartService.addToShoppingCart(reinstatementId, 15).then((data) => {
            if (data.data) { push('/individual/shoppingcart'); }

        })
    }

    return (
        <div>
            <Container fluid>
                <b>Engineer Intern Reinstatement</b>
                <h4 className="mb-3">Review</h4>
                <Row>
                    <Col>
                        <Information content={GetReinstatementInformationContent("review")} className="mb-3" />
                    </Col>
                </Row>
                {hasLoaded ?
                    <>
                        <br />
                        {sectionData.isUserEditable ?
                            <Button onClick={validateReinstatement} name="reviewReinstatement">Validate Reinstatement</Button> : <ReviewPdf id={reinstatementId} parentTypeId={2} />
                        }
                        {
                            (!hasIssues && sectionData.isUserEditable) && <>
                                <span className="ms-2"><ReviewPdf id={reinstatementId} parentTypeId={2} /></span>
                                <Button name="addToCartBtn" onClick={submitReinstatement} variant="danger" className="ms-2">Submit Reinstatement</Button>
                            </>
                        }
                        <Button name="backToSections" as={Link} to="/individual/eiReinstatement/sections" variant="primary" className="ms-2" >Back to Sections</Button>
                        <br />
                        <br />
                        {violationIssuesHtml}
                    </>
                    : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default ReviewPage